import { useMemo } from "preact/hooks";

export function useSortedArray<TItem, TKey>(data: TItem[] | null, getter: ((item: TItem) => TKey) | null, ascending: boolean) {
    return useMemo(() => 
        (data && getter)
            ? [...data].sort((a, b) => {
                const va = getter(a);
                const vb = getter(b);
                if (va < vb) return ascending ? -1 : 1;
                if (va > vb) return ascending ? 1 : -1;
                return 0;
            })
            : data
    , [data, getter, ascending])
}

export function useFilteredArray<TItem>(data: TItem[] | null, filter: ((item: TItem, index: number) => boolean) | null) {
    return useMemo(() =>
        (data && filter)
            ? data.filter(filter)
            : data
    , [data, filter])
}
